import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    uploadBrowseMessage: {
      browse: ' browse ',
      files: 'your documents in PDF, JPG or PNG format',
      or: 'or',
    },
    uploadDescription: 'or **browse** to choose a file',
    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    uploadTitle: {
      regular: 'Drag and drop to upload your document',
      touch: 'Touch here to upload your document',
    },
  },
  fr: {
    uploadBrowseMessage: {
      browse: ' parcourez ',
      files: 'vos documents au format PDF, JPG ou PNG',
      or: 'ou',
    },
    uploadDescription: 'ou **sélectionnez** un fichier',
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadTitle: {
      regular: 'Déposez votre document ici',
      touch: 'Touchez ici pour télécharger votre document',
    },
  },
});
